import { shareCvMiddleware } from './api'

export default [shareCvMiddleware] as const
